import { Info } from "@assets";
import { Row } from "@components/Flex";
import { BodySmall } from "@components/Typography";
import { Flow, Routes } from "@ctypes";
import { useNavigateToStep, useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";

export const BankLinkingErrorBanner = () => {
  const styles = useStyles();
  const { disconnectedAccounts } = useUser();
  const navigate = useNavigateToStep();

  const handlePress = () => {
    navigate(Routes.BankLinking, { state: {
      flow: Flow.Relinking,
      bankLinkId: disconnectedAccounts?.[0]?.id,
    } });
  };

  const logo = disconnectedAccounts?.[0]?.assets?.logo;

  return (
    <div style={styles.container} onClick={handlePress} role="button">
      <Row style={styles.content}>
        <Row>
          <div style={styles.icon}>
            {logo ? <img src={logo} alt="" style={styles.logo} /> : <Info size={24} />}
          </div>
          <BodySmall style={styles.title}>
            {i18n.t(Translations.DisclaimerBankConnectionError)}
          </BodySmall>
        </Row>
        <BodySmall style={styles.subtitle}>
          {i18n.t(Translations.DisclaimerBankConnectionErrorPrompt)}
        </BodySmall>
        <BodySmall style={styles.linkHint}>
          {i18n.t(Translations.DisclaimerBankConnectionErrorLinkHint)}
        </BodySmall>
      </Row>
    </div>
  );
};
